"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[485],{

/***/ 8485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ clearDraftStorage; },
/* harmony export */   "G9": function() { return /* binding */ saveDraftToStorage; },
/* harmony export */   "Hp": function() { return /* binding */ isFieldEditable; },
/* harmony export */   "L_": function() { return /* binding */ getLobPrefix; },
/* harmony export */   "Nh": function() { return /* binding */ isFieldVisible; },
/* harmony export */   "OP": function() { return /* binding */ validateField; },
/* harmony export */   "Rm": function() { return /* binding */ hasAllRequiredValues; },
/* harmony export */   "Ul": function() { return /* binding */ groupFieldsBySection; },
/* harmony export */   "df": function() { return /* binding */ mergeDraftValues; },
/* harmony export */   "fq": function() { return /* binding */ buildSubmitPayload; },
/* harmony export */   "h9": function() { return /* binding */ flattenFinancialData; },
/* harmony export */   "jr": function() { return /* binding */ applySyncGroupValue; },
/* harmony export */   "wr": function() { return /* binding */ validateAllFields; },
/* harmony export */   "xB": function() { return /* binding */ loadDraftFromStorage; },
/* harmony export */   "xT": function() { return /* binding */ mapDropdownOptions; },
/* harmony export */   "yo": function() { return /* binding */ clearAllLegalDocumentDrafts; }
/* harmony export */ });
/* unused harmony exports getFieldValue, getDisplayValue */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(253);
/* harmony import */ var utils_validation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4150);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1485);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44);







function getLobPrefix(partnerId, permissions) {
    var ref;
    if (permissions === null || permissions === void 0 ? void 0 : permissions.lob) {
        return permissions.lob;
    }
    if (utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .autoLobPartners.includes */ .co.includes(partnerId) || (permissions === null || permissions === void 0 ? void 0 : (ref = permissions.permission_list) === null || ref === void 0 ? void 0 : ref.includes("access_only_auto_commercial_flow"))) {
        return "auto-lob";
    }
    if (utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .autoPartnershipPartners.includes */ .ZO.includes(partnerId)) {
        return "auto-partnership";
    }
    return "embedded";
}
function flattenFinancialData(data) {
    var uiConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], partnerName = arguments.length > 2 ? arguments[2] : void 0;
    var values = {};
    var bank = (data === null || data === void 0 ? void 0 : data.bank_details) || {};
    var gst = data === null || data === void 0 ? void 0 : data.gst_details;
    var pan = data === null || data === void 0 ? void 0 : data.pan_details;
    var hasAnyPersistedData = !!((data === null || data === void 0 ? void 0 : data.bank_details) || (data === null || data === void 0 ? void 0 : data.gst_details) || (data === null || data === void 0 ? void 0 : data.pan_details));
    var nameSoT = (partnerName || "").trim();
    values.dealership_name = nameSoT || (gst === null || gst === void 0 ? void 0 : gst.dealership_name) || "";
    values.gst_type = (gst === null || gst === void 0 ? void 0 : gst.type) ? {
        value: gst.type,
        displayValue: capitalize(gst.type)
    } : {
        value: "",
        displayValue: ""
    };
    values.gst_number = (gst === null || gst === void 0 ? void 0 : gst.number) || "";
    values.pan_number = (pan === null || pan === void 0 ? void 0 : pan.number) || "";
    values.pan_image_url = toUploadState(pan === null || pan === void 0 ? void 0 : pan.image_url);
    values.bank_name = bank.bank_name || "";
    values.beneficiary_name = nameSoT || bank.beneficiary_name || "";
    values.ifsc_code = bank.ifsc_code || "";
    values.account_number = bank.account_number || "";
    values.confirm_account_number = bank.account_number || "";
    values.cancelled_cheque_image_url = toUploadState(bank.cancelled_cheque_image_url);
    values.tnc = false;
    uiConfig.forEach(function(field) {
        var ref, ref1;
        var key = (ref = field.props) === null || ref === void 0 ? void 0 : ref.key_name;
        if (!key) return;
        if (((ref1 = field.props) === null || ref1 === void 0 ? void 0 : ref1.default) !== undefined && values[key] === undefined) {
            values[key] = field.props.default;
        }
        if (field.component === "dropdown" && typeof values[key] === "string") {
            var ref2;
            values[key] = optionFromValue((ref2 = field.props) === null || ref2 === void 0 ? void 0 : ref2.options, values[key]);
        }
        if (field.component === "document_upload" && typeof values[key] === "string") {
            values[key] = toUploadState(values[key]);
        }
    });
    if (hasAnyPersistedData) {
        values.gst_applicable = !!gst;
    } else if (values.gst_applicable === undefined) {
        var ref;
        var gstField = uiConfig.find(function(field) {
            var ref;
            return ((ref = field.props) === null || ref === void 0 ? void 0 : ref.key_name) === "gst_applicable";
        });
        values.gst_applicable = (gstField === null || gstField === void 0 ? void 0 : (ref = gstField.props) === null || ref === void 0 ? void 0 : ref.default) !== undefined ? gstField.props.default : true;
    }
    return values;
}
function capitalize(value) {
    if (!value) return "";
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function optionFromValue(options, value) {
    var match = options === null || options === void 0 ? void 0 : options.find(function(opt) {
        return opt.value === value;
    });
    return {
        value: value,
        displayValue: (match === null || match === void 0 ? void 0 : match.display_value) || (match === null || match === void 0 ? void 0 : match.displayValue) || capitalize(value)
    };
}
function toUploadState(url) {
    if (!url) {
        return {
            name: "",
            uploadStatus: "",
            url: ""
        };
    }
    return {
        name: url.split("/").pop() || "document",
        uploadStatus: "uploaded",
        url: url
    };
}
function isFieldVisible(field, values) {
    var ref;
    var visibleWhen = (ref = field.props) === null || ref === void 0 ? void 0 : ref.visible_when;
    if (!visibleWhen) return true;
    return Object.entries(visibleWhen).every(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], expected = _param[1];
        var current = values[key];
        if (typeof expected === "boolean") {
            return Boolean(current) === expected;
        }
        if (typeof current === "object" && (current === null || current === void 0 ? void 0 : current.value) !== undefined) {
            return current.value === expected;
        }
        return current === expected;
    });
}
/** Name SoT fields set `editable` explicitly; other fields default to editable. */ function isFieldEditable(field) {
    if (!field.props || !("editable" in field.props)) {
        return true;
    }
    return field.props.editable === true;
}
function applySyncGroupValue(uiConfig, values, changedKey, nextValue) {
    var ref;
    var changedField = uiConfig.find(function(f) {
        var ref;
        return ((ref = f.props) === null || ref === void 0 ? void 0 : ref.key_name) === changedKey;
    });
    var syncGroup = changedField === null || changedField === void 0 ? void 0 : (ref = changedField.props) === null || ref === void 0 ? void 0 : ref.sync_group;
    if (!syncGroup) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, values), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, changedKey, nextValue));
    }
    var next = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, values), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, changedKey, nextValue));
    uiConfig.forEach(function(field) {
        var ref;
        if (((ref = field.props) === null || ref === void 0 ? void 0 : ref.sync_group) === syncGroup && field.props.key_name !== changedKey) {
            next[field.props.key_name] = nextValue;
        }
    });
    return next;
}
function getFieldValue(field, values) {
    return values[field.props.key_name];
}
function getDisplayValue(field, values) {
    var value = getFieldValue(field, values);
    if (field.component === "yes_no") {
        return value ? "Yes" : "No";
    }
    if (field.component === "dropdown") {
        return (value === null || value === void 0 ? void 0 : value.displayValue) || (value === null || value === void 0 ? void 0 : value.display_value) || (value === null || value === void 0 ? void 0 : value.value) || "";
    }
    if (field.component === "document_upload") {
        return (value === null || value === void 0 ? void 0 : value.url) ? "Uploaded" : "Not uploaded";
    }
    if (field.component === "tnc_checkbox") {
        return value ? "Accepted" : "Not accepted";
    }
    return value == null ? "" : String(value);
}
function validateField(field, values) {
    if (!isFieldVisible(field, values)) return "";
    var key = field.props.key_name;
    var value = values[key];
    var validators = field.props.validators || [];
    if (field.required) {
        if (field.component === "document_upload") {
            if (!(value === null || value === void 0 ? void 0 : value.url) || value.uploadStatus !== "uploaded") {
                return "Please upload ".concat(field.label);
            }
        } else if (field.component === "dropdown") {
            if (!(value === null || value === void 0 ? void 0 : value.value)) {
                return "Please select ".concat(field.label);
            }
        } else if (field.component === "yes_no") {
        // boolean always present
        } else if (field.component === "tnc_checkbox") {
            if (!value) {
                return "Please accept Terms and Conditions";
            }
        } else if (!value || String(value).trim().length === 0) {
            return "Please enter ".concat(field.label);
        }
    }
    var validatorError = validators.map(function(validator) {
        if (validator === "gst") {
            if (!(0,utils_validation__WEBPACK_IMPORTED_MODULE_6__/* .gstValidation */ .sU)(String(value || ""))) {
                return "Please enter a valid GST number";
            }
        }
        if (validator === "pan") {
            if (!(0,utils_validation__WEBPACK_IMPORTED_MODULE_6__/* .panValidation */ .Vw)(String(value || ""))) {
                return "Please enter a valid PAN number";
            }
        }
        if (validator === "gst_pan_match") {
            var gstApplicable = Boolean(values.gst_applicable);
            if (!(0,utils_validation__WEBPACK_IMPORTED_MODULE_6__/* .gstPanValidation */ .ee)(String(values.gst_number || ""), String(value || ""), gstApplicable)) {
                return "Please enter a valid PAN number";
            }
        }
        if (validator.startsWith("min_length:")) {
            var min = Number(validator.split(":")[1]);
            if (String(value || "").length < min) {
                return "Please enter a valid ".concat(field.label.toLowerCase());
            }
        }
        if (validator.startsWith("matches:")) {
            var otherKey = validator.split(":")[1];
            if (String(value || "") !== String(values[otherKey] || "")) {
                return "Account number does not match. Please check the entered account number";
            }
        }
        if (validator === "ifsc") {
            if (!value || String(value).length < 5) {
                return "Please enter a valid IFSC code";
            }
        }
        return "";
    }).find(function(message) {
        return message.length > 0;
    });
    return validatorError || "";
}
function validateAllFields(uiConfig, values, options) {
    var errors = {};
    var valid = true;
    uiConfig.forEach(function(field) {
        var ref;
        if (!isFieldVisible(field, values)) return;
        var error = validateField(field, values);
        if (error) {
            errors[field.props.key_name] = error;
            valid = false;
        } else {
            errors[field.props.key_name] = "";
        }
        if (((ref = field.props.validators) === null || ref === void 0 ? void 0 : ref.includes("ifsc")) && !(options === null || options === void 0 ? void 0 : options.skipIfscRemote) && (options === null || options === void 0 ? void 0 : options.isValidIfsc) === false) {
            errors[field.props.key_name] = "Please enter a valid IFSC code";
            valid = false;
        }
    });
    return {
        valid: valid,
        errors: errors
    };
}
function hasAllRequiredValues(uiConfig, values, isValidIfsc) {
    var valid = validateAllFields(uiConfig, values, {
        isValidIfsc: isValidIfsc
    }).valid;
    return valid;
}
function buildSubmitPayload(uiConfig, values, options) {
    var bankDetails = {};
    var panDetails = {
        number: "",
        image_url: ""
    };
    var gstDetails;
    var gstApplicable = Boolean(values.gst_applicable);
    var shouldIncludeField = function(field) {
        var ref;
        if (!isFieldVisible(field, values)) return false;
        if ((field.props.key_name === "dealership_name" || field.props.key_name === "beneficiary_name") && (isFieldEditable(field) || (options === null || options === void 0 ? void 0 : options.includeNameFields))) {
            return true;
        }
        return ((ref = field.props) === null || ref === void 0 ? void 0 : ref.submit) !== false;
    };
    uiConfig.forEach(function(field) {
        if (!shouldIncludeField(field)) return;
        var key = field.props.key_name;
        var raw = values[key];
        switch(key){
            case "bank_name":
                bankDetails.bank_name = String(raw || "");
                break;
            case "beneficiary_name":
                bankDetails.beneficiary_name = String(raw || "");
                break;
            case "ifsc_code":
                bankDetails.ifsc_code = String(raw || "");
                break;
            case "account_number":
                bankDetails.account_number = String(raw || "");
                break;
            case "cancelled_cheque_image_url":
            case "cancelled_cheque":
                bankDetails.cancelled_cheque_image_url = (raw === null || raw === void 0 ? void 0 : raw.url) || "";
                break;
            case "pan_number":
                panDetails = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, panDetails), {
                    number: String(raw || "")
                });
                break;
            case "pan_image_url":
            case "pan_image":
                panDetails = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, panDetails), {
                    image_url: (raw === null || raw === void 0 ? void 0 : raw.url) || ""
                });
                break;
            case "dealership_name":
                gstDetails = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, gstDetails || {
                    type: "",
                    number: "",
                    dealership_name: ""
                }), {
                    dealership_name: String(raw || "")
                });
                break;
            case "gst_type":
                if (gstApplicable) {
                    gstDetails = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, gstDetails || {
                        type: "",
                        number: "",
                        dealership_name: ""
                    }), {
                        type: (raw === null || raw === void 0 ? void 0 : raw.value) || String(raw || "")
                    });
                }
                break;
            case "gst_number":
                if (gstApplicable) {
                    gstDetails = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, gstDetails || {
                        type: "",
                        number: "",
                        dealership_name: ""
                    }), {
                        number: String(raw || "")
                    });
                }
                break;
            default:
                break;
        }
    });
    // dealership_name may live in identity section while gst is optional —
    // include dealership on gst when gst applicable even if only set once
    if (gstApplicable) {
        var ref;
        gstDetails = {
            dealership_name: String(values.dealership_name || (gstDetails === null || gstDetails === void 0 ? void 0 : gstDetails.dealership_name) || ""),
            type: String(((ref = values.gst_type) === null || ref === void 0 ? void 0 : ref.value) || (gstDetails === null || gstDetails === void 0 ? void 0 : gstDetails.type) || ""),
            number: String(values.gst_number || (gstDetails === null || gstDetails === void 0 ? void 0 : gstDetails.number) || "")
        };
    }
    var payload = {
        bank_details: bankDetails,
        pan_details: panDetails
    };
    if (gstDetails && (gstApplicable || gstDetails.dealership_name)) {
        payload.gst_details = gstDetails;
    }
    return payload;
}
function groupFieldsBySection(uiConfig, values) {
    var order = [];
    var map = {};
    uiConfig.forEach(function(field) {
        var ref;
        if (!isFieldVisible(field, values)) return;
        if (field.component === "tnc_checkbox") return;
        var section = ((ref = field.props) === null || ref === void 0 ? void 0 : ref.section) || "identity";
        if (!map[section]) {
            map[section] = [];
            order.push(section);
        }
        map[section].push(field);
    });
    return order.map(function(section) {
        return {
            section: section,
            fields: map[section]
        };
    });
}
function loadDraftFromStorage(partnerId, groupName) {
    if (!partnerId || !groupName) return null;
    try {
        var key = (0,_types__WEBPACK_IMPORTED_MODULE_1__/* .getLegalDocumentStorageKey */ .d9)(partnerId, groupName);
        var raw = localStorage.getItem(key);
        // One-time migrate from unscoped legacy key into this partner/group slot
        if (!raw) {
            var legacy = localStorage.getItem(_types__WEBPACK_IMPORTED_MODULE_1__/* .LEGACY_LOCAL_STORAGE_KEY */ .Nb);
            if (legacy && legacy !== "{}") {
                localStorage.setItem(key, legacy);
                localStorage.removeItem(_types__WEBPACK_IMPORTED_MODULE_1__/* .LEGACY_LOCAL_STORAGE_KEY */ .Nb);
                raw = legacy;
            }
        }
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || JSON.stringify(parsed) === "{}") return null;
        return parsed;
    } catch (e) {
        return null;
    }
}
function saveDraftToStorage(partnerId, groupName, values) {
    if (!partnerId || !groupName) return;
    try {
        localStorage.setItem((0,_types__WEBPACK_IMPORTED_MODULE_1__/* .getLegalDocumentStorageKey */ .d9)(partnerId, groupName), JSON.stringify(values));
    } catch (e) {
    // ignore quota / private mode
    }
}
function clearDraftStorage(partnerId, groupName) {
    if (!partnerId || !groupName) return;
    try {
        localStorage.removeItem((0,_types__WEBPACK_IMPORTED_MODULE_1__/* .getLegalDocumentStorageKey */ .d9)(partnerId, groupName));
        // Drop legacy key if still present so it cannot leak into another group
        localStorage.removeItem(_types__WEBPACK_IMPORTED_MODULE_1__/* .LEGACY_LOCAL_STORAGE_KEY */ .Nb);
    } catch (e) {
    // ignore
    }
}
/** Clears every legal-documents draft (scoped + legacy). Use on logout. */ function clearAllLegalDocumentDrafts() {
    try {
        var keysToRemove = [];
        for(var i = 0; i < localStorage.length; i += 1){
            var key = localStorage.key(i);
            if (key && (key === _types__WEBPACK_IMPORTED_MODULE_1__/* .LEGACY_LOCAL_STORAGE_KEY */ .Nb || key.startsWith(_types__WEBPACK_IMPORTED_MODULE_1__/* .LOCAL_STORAGE_KEY_PREFIX */ .io))) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach(function(key) {
            return localStorage.removeItem(key);
        });
    } catch (e) {
    // ignore
    }
}
function mergeDraftValues(base, draft) {
    if (!draft) return base;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, base, draft), {
        pan_image_url: draft.pan_image_url || base.pan_image_url,
        cancelled_cheque_image_url: draft.cancelled_cheque_image_url || base.cancelled_cheque_image_url,
        gst_type: draft.gst_type || base.gst_type
    });
}
function mapDropdownOptions() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return options.map(function(opt) {
        return {
            value: opt.value,
            displayValue: opt.display_value || opt.displayValue || opt.value
        };
    });
}


/***/ }),

/***/ 44:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nb": function() { return /* binding */ LEGACY_LOCAL_STORAGE_KEY; },
/* harmony export */   "XQ": function() { return /* binding */ SECTION_TITLES; },
/* harmony export */   "d9": function() { return /* binding */ getLegalDocumentStorageKey; },
/* harmony export */   "io": function() { return /* binding */ LOCAL_STORAGE_KEY_PREFIX; }
/* harmony export */ });
var SECTION_TITLES = {
    identity: "",
    gst: "",
    pan: "",
    bank: "Bank details",
    footer: ""
};
var LOCAL_STORAGE_KEY_PREFIX = "_legal_document_object_";
/** Legacy unscoped key — cleared on migrate to avoid cross-group leakage. */ var LEGACY_LOCAL_STORAGE_KEY = "_legal_document_object_";
function getLegalDocumentStorageKey(partnerId, groupName) {
    return "".concat(LOCAL_STORAGE_KEY_PREFIX).concat(partnerId, "_").concat(groupName);
}


/***/ }),

/***/ 253:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9474);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3375);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3128);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4321);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ })

}]);